/**
 * Derives the original driver's travelling window (`outboundTraveling`)
 * from a selected parallel ride.
 *
 * When `incidentTimestamp` is provided, the boarding station is the first
 * station whose departure is at or after the incident. If none qualifies,
 * `incidentTimestamp` itself is used as the fromTimestamp.
 *
 * @param {{ stations?: Array<{ departure?: string, arrival?: string }> } | null | undefined} ride
 * @param {string | null | undefined} incidentTimestamp UTC ISO timestamp of the breakdown
 * @returns {{ fromTimestamp: string, toTimestamp: string }}
 */
export const deriveOutboundFromRide = (ride, incidentTimestamp) => {
	if (!ride) return { fromTimestamp: '', toTimestamp: '' };
	const stations = ride.stations ?? [];
	if (stations.length === 0) return { fromTimestamp: '', toTimestamp: '' };

	const last = stations[stations.length - 1];
	const to = last?.arrival ?? '';

	if (incidentTimestamp) {
		const boarding = stations.find((s) => s?.departure && s.departure >= incidentTimestamp);
		return {
			fromTimestamp: boarding?.departure ?? incidentTimestamp,
			toTimestamp: to,
		};
	}

	const first = stations[0];
	return {
		fromTimestamp: first?.departure ?? '',
		toTimestamp: to,
	};
};
